import { QueryObserver as e } from "./contact-channels111.js";
import { useBaseQuery as u } from "./contact-channels112.js";
function m(r, o) {
  return u(r, e);
}
export {
  m as useQuery
};
//# sourceMappingURL=contact-channels42.js.map
